/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Settings_Enable_DescriptionInputs */



/**
* | output |
* | --- |
* | "Turn Uno on for everyone in your organization. Usage is billed as part of your plan, just like chats." |
*
* @param {Uno_Settings_Enable_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_settings_enable_description = /** @type {((inputs?: Uno_Settings_Enable_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Settings_Enable_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktivieren Sie Uno für alle in Ihrer Organisation. Die Nutzung wird wie bei Chats über Ihren Tarif abgerechnet.")
	return /** @type {LocalizedString} */ ("Turn Uno on for everyone in your organization. Usage is billed as part of your plan, just like chats.")
});